import styled from 'styled-components';

export const AMBASSADOR_FEEDBACK_BAR_HEIGHT = 90;

export const Spacer = styled.div`
  height: ${AMBASSADOR_FEEDBACK_BAR_HEIGHT}px;
`;

export const Container = styled.div`
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  height: ${AMBASSADOR_FEEDBACK_BAR_HEIGHT}px;
  padding: 20px 90px;
  border-top: 1px solid ${(props) => props.theme.$gray400};
  background: ${(props) => props.theme.$white};

  .feedback-call {
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-width: 0;
    padding: 0 18px;
    line-height: normal;
  }

  .feedback-label {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: #10a875;
    font-size: 16px;

    .material-icons {
      font-size: 18px;
    }
  }

  .feedback-title {
    overflow: hidden;
    color: ${(props) => props.theme.$dark_slate_blue};
    font-size: 20px;
    font-weight: 900;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  a {
    gap: 10px;
  }

  @media only screen and (max-width: 768px) {
    padding: 12px 16px;

    .feedback-call {
      padding: 0;
    }

    .feedback-label {
      font-size: 13px;
    }

    .feedback-title {
      font-size: 15px;
      white-space: normal;
    }

    a {
      padding: 8px 16px;
    }
  }
`;
